import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import HeroSection from './HeroSection';
import BlogGrid from './BlogGrid';
import SEO from '../../components/common/SEO';

const BlogPage = () => {
  const blogData = [
    {
      id: 1,
      title: 'The Natural Elixir: Unveiling the Health Benefits of Honey',
      date: 'April 29, 2025',
      tags: ['Honey Benefits', 'Health', 'Wellness'],
      description:
        "More than just a culinary delight, honey is a testament to nature's ability to provide us with a nourishing and healing elixir.",
    },
    {
      id: 2,
      title: 'Easy Vegan Hot Honey Recipe',
      date: 'April 29, 2025',
      tags: ['Honey Recipes', 'Vegan', 'Food'],
      description:
        'This versatile hot honey is the ultimate flavor upgrade for salads, sandwiches, stir-fries, and so much more.',
    },
    {
      id: 3,
      title: 'Master Guide – Beekeeping For Beginners',
      date: 'April 29, 2025',
      tags: ['Beekeeping', 'How-To', 'Guides'],
      description:
        'These five blogs answer the significant questions everyone considering keeping their own bees should ask.',
    },
    {
      id: 4,
      title: 'A Journey from Nectar to the Golden Elixir',
      date: 'April 29, 2025',
      tags: ['Elixir Honey', 'Beekeeping', 'Science'],
      description:
        'Delve into the fascinating process of how honey is made, from the collection of nectar to its transformation into the delectable substance we know and love.',
    },
    {
      id: 5,
      title: 'Sacred trees, revered resins, eternal blooms',
      date: 'April 29, 2025',
      tags: ['Elixir Honey'],
      description:
        'Our Balm of Gilead Elixir is a powerful infusion that draws upon sacred trees and their resins, enriched with the eternal bloom of immortelle.',
    },
    {
      id: 6,
      title: 'Sweet Dreams with Elixir',
      date: 'April 29, 2025',
      tags: ['Honey Benefits', 'Wellness', 'Sleep'],
      description:
        "Struggling to fall asleep? Discover how a simple spoonful of Elixir honey can promote relaxation and contribute to a more restful night's sleep.",
    },
  ];
  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Blog"
        description="Explore our latest articles on honey's benefits, recipes, beekeeping insights, stories from Tunisia, and more. Discover the sweet world of Elixir honey."
        keywords="
          honey blog,
          honey benefits articles,
          honey recipes,
          beekeeping guides,
          Elixir honey stories,
          Mediterranean honey blog,
          honey wellness tips,
          honey cooking recipes
        "
      />
      <Header />
      <main className="flex-grow">
        <HeroSection
          title="The Sweet Spot: Discover the World of Elixir"
          description="Explore our latest articles on honey's benefits, recipes, beekeeping insights, stories from Tunisia, and more."
        />
        {/* Blog Intro Paragraph */}
        <section className="max-w-3xl mx-auto px-4 py-6 text-center">
          <h2 className="text-2xl font-bold text-[#d4af37] mb-2">Welcome to the Elixir Honey Blog</h2>
          <p className="text-lg text-[#475467] mb-4">
            Dive into the world of Mediterranean honey! Here you'll find expert tips, health benefits, delicious recipes, and stories from our beekeepers. Whether you're a honey enthusiast or just curious, our blog is your gateway to all things Elixir.
          </p>
        </section>
        {/* Featured Post */}
        <section className="max-w-3xl mx-auto px-4 py-4 mb-4 bg-[#f7fbff] rounded-xl shadow text-left">
          <h3 className="text-xl font-semibold text-[#d4af37] mb-2">Featured: The Natural Elixir – Unveiling the Health Benefits of Honey</h3>
          <p className="text-[#475467] mb-2">More than just a culinary delight, honey is a testament to nature's ability to provide us with a nourishing and healing elixir. <a href="/shop" className="text-[#d4af37] underline hover:text-yellow-600">Shop our healthiest varieties</a> or <a href="/wellness" className="text-[#d4af37] underline hover:text-yellow-600">learn more about honey & wellness</a>.</p>
        </section>
        <BlogGrid blogs={blogData} />
        {/* Internal Links Section */}
        <section className="max-w-3xl mx-auto px-4 py-6 text-center">
          <div className="flex flex-wrap justify-center gap-4 mt-4">
            <a href="/shop" className="text-[#d4af37] underline hover:text-yellow-600">Shop Honey</a>
            <a href="/about" className="text-[#d4af37] underline hover:text-yellow-600">About Elixir</a>
            <a href="/wellness" className="text-[#d4af37] underline hover:text-yellow-600">Honey & Wellness</a>
            <a href="/contact" className="text-[#d4af37] underline hover:text-yellow-600">Contact Us</a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;
